import { v4 as uuidv4 } from 'uuid';
import { createComponentStore } from '../../utils/createComponentStore';

const componentKeyData = (generateId = true) => {
  const data = {
    keyName: '',
    dataType: 'text',
  };
  if (generateId) {
    data.id = uuidv4();
  }
  return data;
};

const keyAuto = () => 'bulkassessment' + uuidv4();

const initData = () => {
  const obj = componentKeyData(false);
  return {
    outputKey: keyAuto(),
    fields: [obj],
  };
};

const onLoadData = (rawData) => {
  const fields = (rawData.fields || []).map((d) => ({
    id: uuidv4(),
    keyName: d.keyName,
    dataType: d.dataType,
  }));
  // v1 compat: map `key` → `outputKey`
  const outputKey = rawData.outputKey || rawData.key || initData().outputKey;
  const result = { ...rawData, fields, outputKey };
  delete result.key;
  return result;
};

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'bulk_assessment',
  endpoint: 'bulk_assessment',
  registryKey: 'bulk_assessment',
  initData,
  onLoadData,
  extraActions: (set, get) => ({
    addComponentKeyData: () => {
      const obj = componentKeyData();
      const data = { ...get().data, fields: [...get().data.fields, obj] };
      set({ data });
    },

    addDataFromExcel: (excelData) => {
      let fields = [];
      for (let i = 0; i < excelData[0].length; i++) {
        let keyName = '';
        if (typeof excelData[0][i] === 'string') {
          keyName = excelData[0][i].toLowerCase().trim().split(' ').join('_');
        } else if (typeof excelData[0][i] === 'number') {
          keyName = excelData[0][i];
        }
        fields.push({ id: uuidv4(), keyName, dataType: 'text' });
      }
      if (fields.length > 0) {
        set({ data: { ...get().data, fields } });
      }
    },

    deleteComponentKeyData: (index) => {
      const fields = [...get().data.fields];
      fields.splice(index, 1);
      set({ data: { ...get().data, fields } });
    },

    setField: (value, index, type) => {
      const fields = get().data.fields.map((f, i) => {
        if (i !== index) return f;
        return { ...f, [type]: value };
      });
      set({ data: { ...get().data, fields } });
    },

    setContent: (value, type) => {
      switch (type) {
        case 'key':
          set({ data: { ...get().data, outputKey: value } });
          return;
        case 'text':
          set({ data: { ...get().data, text: value } });
          return;
      }
    },

    // Backward-compatible alias for prefillComponentStores
    setData: (component) => {
      get().setComponentData(component);
    },
  }),
});

export function getBulkAssessmentStore(componentId) {
  return getStore(componentId);
}

export default defaultStore;
